export const MIN_ACTIVITY_HEIGHT = 40;
export const MIN_TASK_HEIGHT = 60;
export const COLLAPSED_GROUP_HEIGHT = 240;
export const MIN_MILESTONE_HEIGHT = 140;
export const SEARCH_POPUP_MIN_HEIGHT = 40;
export const STUB_HEIGHT = 60;
export const STUB_HEIGHT_DOUBLE = 80;
export const MIN_TEXT_BOX_HEIGHT = 36;
export const MIN_TEXT_BOX_HEIGHT_WITH_LIST = 52;
export const MIN_IMAGE_HEIGHT = 200;
export const MIN_ACTIVITY_WIDTH = 300;
export const COLLAPSED_GROUP_WIDTH = 240;
export const MIN_MILESTONE_WIDTH = 300;
export const STUB_WIDTH = 320;
export const STUB_WIDTH_DOUBLE = 340;
export const MIN_TEXT_BOX_WIDTH = 306;
export const MIN_IMAGE_WIDTH = 300;
export const MS_PER_DAY = 24 * 60 * 60 * 1000;
export const MANUALSORT_GENERIC_PARENT = 'ROOT';
export const P6_WBS_ROOT_PARENT_GUID = 'root';
export const MANUALSORT_TOP_ELEMENT_GUID = 'TOP';
export const CANVAS_EDGE_TYPES = {
  floating: 'floating'
  // TODO: Update css so we can leverage edge types properly summary: 'summary'
};
export const CANVAS_BIDIRECTIONAL_EDGE_CLASS = 'react-flow__edge-bi-directional';
export const EDGE_COLORS = ['#64748b', '#38b6f5', '#f46d37', '#7437f4', '#0d968b', '#f43787'];
export const CONNECT_TO_MARGIN = 200;
export const CONNECT_FROM_MARGIN = 240;
export const STUB_SPACING = 80;
export const CUSTOM_COLOR_MARKER_ID_PREFIX = 'react-flow__arrowclosed-custom-color-';
export const CUSTOM_COLOR_HOVERED_MARKER_ID_PREFIX = 'react-flow__arrowclosed-custom-color-hovered-';
export const CUSTOM_COLOR_CIRCULAR_MARKER_ID_PREFIX = 'react-flow__circular-marker-';
export const CUSTOM_COLOR_BIDIRECTIONAL_MARKER_ID_PREFIX = 'react-flow__bidirectional-marker-';
export const CUSTOM_COLOR_BIDIRECTIONAL_HOVERED_MARKER_ID_PREFIX = 'react-flow__bidirectional-hovered-marker-';

export const TEMPORARY_ELEMENT_UID_PREFIX = 'temp|';
export const ACTIVITY_SPACING = 50;
export const ACTIVITY_HORIZONTAL_SPACING = 50;
export const ACTIVITY_DOUBLE_HEIGHT = 60;
export const MIN_GROUP_WIDTH = 340;
export const MIN_GROUP_HEADER_HEIGHT = 40;
export const MAX_GROUP_HEADER_HEIGHT = 80;
export const MIN_GROUP_HEIGHT_EMPTY_CHILDREN = MIN_GROUP_HEADER_HEIGHT + 2 * ACTIVITY_SPACING + MIN_ACTIVITY_HEIGHT;
export const CANVAS_GRID_RATIO = 10;
export const CANVAS_ELEMENT_SOURCE_HANDLE_WIDTH = 30;
export const CANVAS_ELEMENT_HANDLE_EXTENSION = 10;
export const CANVAS_GROUP_HEADER_HEIGHT = 40;
export const CANVAS_APP_BAR_HEIGHT = 44;
export const MINI_PROJECT_HEADER_CLASS = 'miniProjectHeader';
export const TRACE_PATH_CANVAS_ELEMENT_HANDLE_EXTENSION = 25;
// export const CANVAS_ELEMENT_SOURCE_HANDLE_OFFSET = CANVAS_ELEMENT_SOURCE_HANDLE_WIDTH - CANVAS_ELEMENT_HANDLE_EXTENSION
export const CANVAS_ELEMENT_TARGET_HANDLE_EXTENSION = 10 * 2;
export const GROUP_PADDING = 20;
export const SELECTION_RECT_PADDING = 8;
export const OVERLAP_PADDING = 5;
export const STUB_SNAP_POINT_ADJUSTMENT = 10;
export const SEARCH_POPUP_MIN_WIDTH = 324;
export const SEARCH_POPUP_MAX_WIDTH = 616;
export const GROUP_VERTICAL_SPACING = 60;
export const GROUP_HORIZONTAL_SPACING = 85;
export const ACTIVITY_HORIZONTAL_ALIGNMENT_ZONE = MIN_ACTIVITY_WIDTH + 2 * ACTIVITY_HORIZONTAL_SPACING + ACTIVITY_HORIZONTAL_SPACING;
export const ACTIVITY_VERTICAL_ALIGNMENT_ZONE = MIN_ACTIVITY_HEIGHT + 2 * ACTIVITY_SPACING + ACTIVITY_SPACING;
export const TASK_VERTICAL_ALIGNMENT_ZONE = MIN_TASK_HEIGHT + 2 * ACTIVITY_SPACING + ACTIVITY_SPACING;
export const GROUP_HORIZONTAL_ALIGNMENT_ZONE = COLLAPSED_GROUP_WIDTH + 2 * GROUP_HORIZONTAL_SPACING + GROUP_HORIZONTAL_SPACING;
export const GROUP_VERTICAL_ALIGNMENT_ZONE = COLLAPSED_GROUP_HEIGHT + 2 * GROUP_VERTICAL_SPACING + GROUP_VERTICAL_SPACING;
export const TRACE_PATH_CANVAS_VERTICAL_SPACING = 70;
export const FIT_VIEW_PADDING = 0.2;
// Deep fit floor for the auto layout preview canvases so far-apart elements are always framed
// there. Main canvas fits keep the interactive MIN_ZOOM via useMaxCoverageFitView (PRD-27711).
export const FIT_VIEW_MIN_ZOOM = 0.01;
export const SIDEBAR_WIDTH = 74;
export const TOP_HEADER_HEIGHT = 44;

export const CANVAS_EDGE_ROUTING_OVERLAY_KEY = 'canvasEdgeRoutingOverlay';
export const CANVAS_UGLY_EDGE_PANEL_KEY = 'canvasUglyEdgePanel';
export const CANVAS_SMOOTHSTEP_KEY = 'canvasSmoothStepEdge';
export const CANVAS_EDGE_ANCHOR_KEY = 'canvasEdgeAnchor';
export const CANVAS_NEW_STUBS_KEY = 'canvasNewStubs';
export const CALENDAR_KEY = 'calendarList';
export const LASSO_SELECTION_BOX_ID = 'lasso-selection-box';
export const LASSO_SELECTED_NODE = 'selectedNodeOnLasso';
export const LASSO_SELECTED_STUB_NODE = 'selectedStubNodeOnLasso';
export const LASSO_SELECTED_STUB_NODE_PLACEHOLDER = 'lassoSelectionPlaceHolderClass';
export const DISABLE_ELEMENT_SELECTION_CLASS = 'disableWBSSelection';
export const GROUP_NODE_COUNTS_CLASS = 'groupNodeCounts';
export const GROUP_NODE_EXPAND_ICON_CLASS = 'groupNodeExpandIcon';
export const ACTIVITY_NODE_EXPAND_ICON_CLASS = 'activityNodeExpandIcon';
export const ACTIVITY_NODE_TASKS_PREVIEW_CLASS = 'activityNodeTasksPreview';
export const HIGHLIGHT_CANVAS_EDGE_CLASS = 'reactFlowEdgeHighlight';
export const HIGHLIGHT_CANVAS_NODE_CLASS = 'reactFlowNodeHighlight';
export const DRIVING_EDGE_THICKER_CLASS = 'driving-edge-thicker';
export const CANVAS_NODE_HIGHLIGHT_PLACEHOLDER = 'canvasNodeHighlightPlaceholder';
export const IMAGE_NAME_LOCAL_STORAGE_KEY = 'embedImageName';
export const CONTEXT_MENU_TOOLTIP_SHOWN_KEY = 'contextMenuTooltipShown';
export const BUSY_TOOLTIP_SHOWN_KEY = 'busyTooltipShown';
export const EDGE_SESSION_TOOLTIP_SHOWN_KEY = 'sessionTooltipShown';
export const EDGE_SESSION_TOOLTIP_SHOWN_COUNT_KEY = 'edgeSessionTooltipShownCount';
export const CANVAS_NODE_NAVIGATION_HIGHLIGHT_CLASS = 'tableToCanvasNavigationHighlight'; // Class to highlight borders when navigating to a specific node on Canvas

export const PROJECT_COMMITTED_STATES = {
  COMMITTED: 'committed',
  NOT_COMMITTED: 'notCommitted'
};

export const GROUP_DROPZONE_CLASSNAME = 'GROUP_DROPZONE';

export const OUTPUTS_TAB_INDEXES = {
  IMPORTANT_DATES: 0,
  PROJECT_QUALITY_METRICS: 1,
  LABOUR_USAGE: 2,
  RISK_REGISTER: 3,
  EQUIPMENT_USAGE: 4
};

export const PROJECT_OUTPUTS_TABS = {
  importantDates: 'important_dates',
  projectQualityMetrics: 'project_quality_metrics',
  resourceUsage: 'resource_usage',
  riskRegister: 'risk_register'
};

export const MAX_RECURSIVE_DEPTH = 100;

export const DESIGN_SYSTEM_TABS = {
  icons: 'icons',
  canvas: 'canvas',
  table: 'table',
  gantt: 'gantt',
  designComponents: 'design-components'
};

export const PROJECT_TABS = {
  CANVAS: 'canvas',
  TABLE: 'table',
  GANTT: 'gantt',
  IMPORTANT_DATES: 'importantDates',
  LABOR_USAGE: 'laborUsage',
  EQUIPMENT_USAGE: 'equipmentUsage',
  EXPORTS: 'exports',
  TIMESPAN_RESOURCES: 'timespan-resources',
  DCMA_COMPLIANCE: 'schedule-qual',
  COMPARE: 'compare',
  SIMULATIONS: 'simulations',
  DASHBOARD: 'dashboard',
  SETTINGS: 'settings',
  GROUP_REORDER: 'group-reorder'
};

export const TIMESPAN_RESOURCE_ELEMENT_TYPE = 'timeSpan';
export const PREVIOUS_REACT_APP_VERSION_KEY = 'previous_react_app_version_';
export const CURRENT_ORGANIZATION_ID_KEY = 'current_organization_id';
export const CURRENT_WORKSPACE_ID_KEY = 'current_workspace_id';
export const CURRENT_PROJECT_IDS_KEY = 'current_project_ids';
export const CURRENT_PROJECT_ID_KEY = 'current_project_id';
export const CANVAS_POSITION_PREFIX_KEY = 'canvas_position_';
export const MINI_PROJECT_PREFIX_KEY = 'mini_project_';
export const SCHEDULE_STALE_PREFIX_KEY = 'schedule_stale_';
export const NEXT_MINI_PROJECT_PREFIX_KEY = 'next_mini_project_';
export const GROUP_HEADER_DOM_ID_PREFIX = 'group-header-';
export const CANVAS_EDGE_HANDLE_CLASS = 'canvas-edge-handle';
export const X_PLANERA_ORGANIZATION_ID = 'X-Planera-OrgId';
export const X_PLANERA_WORKSPACE_ID = 'X-Planera-WorkspaceId';
export const DO_NOT_SEND_HEADER = 'DO_NOT_SEND_HEADER';
export const AMPLIFY_AUTH_ERROR_KEY = '#error_description';
export const CUSTOM_AMPLIFY_ERROR_ID = 'custom-amplify-error';
export const NEED_PASSWORD_SETUP_ATTRIBUTE_KEY = 'custom:permPassword';

export const INDEX_NAVIGATION_PATH = '/';
export const MAGIC_LOGIN_PATH = 'magic-login';
export const CONNECTION_CLOSED_REDIRECT_PATH = 'connection-closed';
export const ORGANIZATION_SETTINGS_PATH = 'organization-settings';
export const HOMEPAGE_NAVIGATION_PARAM_TAB = 'currentHomeTab';
export const HOMEPAGE_USERS_BULK_INVITE_SEGMENT = 'invite';
export const HOMEPAGE_SUB_TAB_KEY = 'homepageSubTabKey';
export const ROLLUP_REPORT_TAB_KEY = 'reportResourceTabKey';
export const PROJECTS_NAVIGATION_PATH = 'projects';
export const PROJECT_NAVIGATION_PATH = 'project';
export const PROJECT_NAVIGATION_CANVAS = 'canvas';
export const PROJECT_NAVIGATION_TABLE = 'table';
export const PROJECT_NAVIGATION_GANTT = 'gantt';
export const PROJECT_NAVIGATION_IMPORTANT_DATES = 'importantDates';
export const PROJECT_NAVIGATION_LABOR_USAGE = 'laborUsage';
export const PROJECT_NAVIGATION_EQUIPMENT_USAGE = 'equipmentUsage';
export const PROJECT_NAVIGATION_EXPORTS = 'exports';
export const PROJECT_NAVIGATION_TIMESPAN_RESOURCES = 'timespan-resources';
export const PROJECT_NAVIGATION_LABOR_OUTPUT = 'labor-output';
export const PROJECT_NAVIGATION_EQUIPMENT_OUTPUT = 'equipment-output';
export const PROJECT_NAVIGATION_DCMA_COMPLIANCE = 'schedule-qual';
export const PROJECT_NAVIGATION_COMPARE = 'compare';
export const PROJECT_NAVIGATION_SIMULATIONS = 'simulations';
export const PROJECT_NAVIGATION_DASHBOARD = 'dashboard';
export const PROJECT_NAVIGATION_SETTINGS = 'settings';
export const PROJECT_NAVIGATION_GROUP_REORDER = 'group-reorder';
export const PROJECT_NAVIGATION_TIMESPAN_RESOURCES_TAB_KEY = 'timespanTabKey';
export const PROJECT_NAVIGATION_PARAM_PROJECTID = 'projectId';
export const PROJECT_NAVIGATION_PARAM_WORKSPACE = 'workspaceId';
export const PROJECT_NAVIGATION_PARAM_ORGANIZATION = 'organizationId';
export const PROJECT_NAVIGATION_PARAM_PROJECTVIEW = 'currentTab';
export const PROJECT_NAVIGATION_BOOKMARK = 'bookmark';
export const PROJECT_NAVIGATION_PARAM_BOOKMARK = 'bookmarkId';
export const PROJECT_NAVIGATION_EMBED_IMAGE = 'image';
export const PROJECT_NAVIGATION_PARAM_EMBED_IMAGE = 'imageId';
export const PROJECT_NAVIGATION_DOWNLOAD_PDF = 'download/pdf';
export const PROJECT_NAVIGATION_CHAT_PDF = 'chat-pdf';
export const PROJECT_CREATION_PATH = 'project-create';
export const PROJECT_TOO_LARGE_FOR_IPAD_PATH = 'project-too-large';

export const PROCORE_COMPANY_ID_KEY = 'procoreCompanyId';
export const PROCORE_COMPANY_ID_PARAM_KEY = 'company_id';

export const ELEMENT_FEED_GROUP = 'user';
export const NOTIFICATIONS_FEED_GROUP = 'notification';
export const PROJECT_FEED_GROUP = 'projects';

export const REACT_FLOW_CANVAS_COMPONENT_ID = 'reactFlowCanvasId';
export const REACT_FLOW_CANVAS_WRAPPER_COMPONENT_ID = 'canvasTop';
export const REACT_FLOW_CANVAS_CONTAINER_CLASS = '.react-flow__container';
export const CANVAS_CONTROLS_COMPONENT_ID = 'canvasControls';
export const FAKE_MINI_PROJECT_ID = '3e487d92-b3ee-4e27-80d9-a7cfb7ccd8b9';
export const CONNECT_TO_EXISTING_NODE_BUTTON_ID = 'connect_to_existing_node_button';
export const NODE_DEFAULT_NAMES = {
  activity: 'Activity',
  task: 'Task',
  group: 'Group',
  milestoneStart: 'Start Milestone',
  milestoneInterim: 'Interim Milestone',
  milestoneEnd: 'Finish Milestone',
  searchBox: 'Search Box',
  connectFrom: 'Connect From',
  connectTo: 'Connect To',
  text: 'Text Box',
  timeSpan: 'Timespan', // Shouldn't ever show
  empty: '',
  image: 'Image'
};

// Should be used only for the Canvas
export const CURSOR_STATES = {
  GRAB_CURSOR: 'grabCanvasCursor',
  SUCCESSOR_CURSOR: 'successorCanvasCursor',
  PREDECESSOR_CURSOR: 'predecessorCanvasCursor',
  OMNIDIRECTIONAL_CURSOR: 'omnidirectionalCanvasCursor',
  HORIZONTAL_CURSOR: 'horizontalCanvasCursor',
  VERTICAL_CURSOR: 'verticalCanvasCursor',
  TOP_RIGHT_TO_BOTTOM_LEFT_DIAGONAL_CURSOR: 'neCanvasCursor',
  TOP_LEFT_TO_BOTTOM_RIGHT_DIAGONAL_CURSOR: 'nwCanvasCursor',
  ACTIVITY: 'activityCanvasCursor',
  TASK: 'taskCanvasCursor',
  GROUP: 'groupCanvasCursor',
  MILESTONE_START: 'startMilestoneCanvasCursor',
  MILESTONE_INTERIM: 'interimMilestoneCanvasCursor',
  MILESTONE_END: 'endMilestoneCanvasCursor',
  MOVE_ELEMENT: 'moveElementCanvasCursor',
  TEXT_BOX: 'textNodeCanvasCursor',
  IMAGE: 'imageCanvasCursor',
  COMMENTS: 'commentsCanvasCursor',
  MANNY_CONTEXT: 'mannyContextCanvasCursor'
};

export const GROUP_STUB_TYPES = {
  IN: 'in',
  OUT: 'out'
};
export const PARENT_ID_SEPARATOR = '_';
